import React, { Component } from 'react'
import {Button} from 'react-bootstrap'
import Wait from './Wait'
import {shuffle, next, playAgain, quitGame} from '../../functions/firebase'
import Done from './Done'



export default class Display extends Component {

    render() {
        let found = false
     
        this.props.data.questions.forEach(q =>{
            if(q.player === this.props.player.uid){
                 found = true
            }
        })
        if(!found){
            this.props.page('question')
        }
        return (
            <div className='display'>
                {this.props.data.questions.length === this.props.data.names.length && this.props.data.names.length > 1? 
                <div>
                    {this.props.data.shuffle? 
                    <>
                       {this.props.data.names.length > this.props.data.turn? 
                       
                       
                        <div>
                            question:
                    <p className="question">{this.props.data.questions[this.props.data.turn].question}</p>
                    <p className="name">assigned to: {this.props.data.names[this.props.data.turn].name}</p>
                        {this.props.isadmin? 
                        <>
                     
                        <Button variant="outline-primary" onClick={()=>next(this.props.gameId, this.props.data.turn)}>next</Button>
                        </>
                        :""}

                        </div>
                       :<div>
                           <Done /> 
                           {this.props.isadmin? 
                        <>
                     <div className="center">

                        <Button style={{width:'250px'}} variant="info" onClick={()=>playAgain(this.props.gameId)}>play again</Button>
                     </div>
                     <div className="center" style={{marginTop:'10px'}}>
                        <Button style={{width:'250px'}} variant="danger" onClick={()=>quitGame(this.props.gameId)}>quit</Button>

                     </div>
                    
                        </>
                        :""}
                    </div>}
                        </>
                    : <div>
                        {this.props.isadmin? 
                        <Button  variant="outline-info" style={{width:'70%', fontSize:'30px', margin:'0 15%'}} onClick={()=>shuffle(this.props.data, this.props.gameId)}>Start Game</Button>
                        :<Wait/>}
                    </div>}
                    
                </div>
            
            :<Wait/>}
            </div>
        )
    }
}
